import { CombinedGraphQLErrors } from "@apollo/client";
import { ErrorLink } from "@apollo/client/link/error";
import { getActiveWorkspaceId, setActiveWorkspaceId } from "./storage";

/** The backend's TicketonErrorCodes name for a workspace id the caller cannot act in. */
export const WORKSPACE_NOT_ACCESSIBLE_ERROR_CODE = "MarketingWorkspaceNotAccessible";

/**
 * The workspace id we send is authoritative for the backend: one it cannot resolve for the
 * caller (stale after switching environments, or a workspace we were removed from) is refused on
 * every field. Recovering is our job: forget the stored id and retry the operation without it,
 * which lets the workspace list load and a valid one be picked again.
 *
 * Place this link before the header link so the retry recomputes the headers.
 */
export function createStaleWorkspaceLink() {
  return new ErrorLink(({ error, operation, forward }) => {
    const isStaleWorkspace =
      CombinedGraphQLErrors.is(error) &&
      error.errors.some(
        (graphQLError) => graphQLError.extensions?.errorCode === WORKSPACE_NOT_ACCESSIBLE_ERROR_CODE
      );

    if (!isStaleWorkspace || !getActiveWorkspaceId()) return undefined;

    setActiveWorkspaceId(null);

    return forward(operation);
  });
}
